import * as $lustre from '../../../lustre/lustre.mjs'
import * as $effect from '../../../lustre/lustre/effect.mjs'
import * as $element from '../../../lustre/lustre/element.mjs'
import * as $event from '../../../lustre/lustre/event.mjs'
import * as $gleam from '../../gleam.mjs'

export class LustrePortal extends HTMLElement {
  constructor() {
    super()
    this._model = 0
    this._mount = document.createElement('div')
    this._mount.setAttribute('class', 'lustre-portal')
    this._mount.addEventListener('freyja-traverse', e =>
      this._emitPortalEvent(e)
    )
    this._render = document.createElement('div')
    this._mount.appendChild(this._render)
    this._content = $gleam.List.fromArray([$element.none()])
    this._watchContent()
  }

  connectedCallback() {
    document.body.appendChild(this._mount)
    const init = () => [this._model, $effect.none()]
    const update = (model, msg) => {
      if (msg instanceof Refresh) return [this._model, $effect.none()]
      return [model, $event.emit('freyja-traverse', msg)]
    }
    const view = _model => this._content
    const app = $lustre.application(init, update, view)
    const result = $lustre.start(app, this._render, null)
    if (result instanceof $gleam.Ok) {
      this._runtime = result[0]
    }
  }

  disconnectedCallback() {
    document.body.removeChild(this._mount)
    if (this._runtime) {
      const shutdown = $lustre.shutdown()
      $lustre.send(this._runtime, shutdown)
    }
  }

  _emitPortalEvent(event) {
    const detail = event.detail
    const options = { bubbles: true, detail, composed: true }
    this.dispatchEvent(new CustomEvent('freyja-traverse', options))
  }

  _watchContent() {
    Object.defineProperty(this, 'content', {
      set(value) {
        this._content = value
        this._model += 1
        if (this._runtime) {
          const empty = $lustre.dispatch(new Refresh())
          $lustre.send(this._runtime, empty)
        }
      },
    })
  }
}

export function register() {
  const name = 'lustre-portal'
  if (window.customElements.get(name))
    return new $gleam.Error(new $lustre.ComponentAlreadyRegistered(name))
  customElements.define(name, LustrePortal)
  return new $gleam.Ok()
}

/** Used to mimic Gleam behaviour, to easy usage of `echo` and other Gleam
 * stuffs. Should not be used outside of portals. */
class Refresh {}
